import { thirdPartyAppEvents, thirdPartySupportService } from '../third-party/service';
import { IframeApp } from '../third-party/interface/iframe-app';
import { getSourceUrl } from '../util';

export const CLASS_CHILDREN = 'app-stack__children';
export const CLASS_CHILDREN_ACTIVE = 'app-stack__children--active';

export class NavAppStack extends HTMLElement {
  private iframes: {
    [key: string]: HTMLIFrameElement;
  } = {};


  connectedCallback(): void {
    thirdPartySupportService.on(thirdPartyAppEvents.UPDATE_APP, (appData) => {
      this.onChange(appData);
    });

    thirdPartySupportService.on(thirdPartyAppEvents.RELOAD_APP, (appData) => {
      this.reloadApp(appData);
    });
  }

  private onChange(appData: IframeApp) {
    let frame = this.iframes[appData.name];

    if (!frame) {
      frame = this.createIframe(appData);
      this.iframes[appData.name] = frame;
      return;
    }

    if (frame.src !== getSourceUrl(appData.src)) {
      frame.src = appData.src;
    }

    if (frame.name !== appData.name) {
      frame.name = appData.name;
    }

    if (appData.active) {
      frame.classList.add(CLASS_CHILDREN_ACTIVE);
    } else {
      frame.classList.remove(CLASS_CHILDREN_ACTIVE);
    }
  }

  private createIframe(appData: IframeApp) {
    const iframe = document.createElement('iframe');
    iframe.src = appData.src;
    iframe.name = appData.name;
    iframe.id = `thirdPartyFrame_${appData.name}`;
    iframe.setAttribute('data-test', 'third-party-frame_' + appData.name);
    iframe.setAttribute('title', appData.name);
    iframe.setAttribute('allow', 'geolocation *; clipboard-read *; clipboard-write *;');
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.setAttribute('allowtransparency', 'true');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('mozallowfullscreen', '');
    iframe.setAttribute('webkitallowfullscreen', '');
    iframe.classList.add(CLASS_CHILDREN);
    iframe.classList.add('l-vertical');
    if (appData.active) {
      iframe.classList.add(CLASS_CHILDREN_ACTIVE);
    }

    this.appendChild(iframe);

    return iframe;
  }

  private reloadApp(appData: IframeApp) {
    if (!this.iframes[appData.name]) {
      return;
    }

    this.iframes[appData.name].remove();
    this.iframes[appData.name] = null;
    this.onChange(appData);
  }

}

window.customElements.define('nav-app-stack', NavAppStack);
